import type { BaseController } from '@infra/controllers/base.controller';
import type { PrerecordedMessage } from '@entities/prerecorded-message';
import type { FetchPrerecordedMessagesUsecase } from './fetch-list-prerecorded-messages.usecase';

export type FetchPrerecordedMessagesOutput = PrerecordedMessage[];

export class FetchPrerecordedMessagesController
  implements BaseController<void, FetchPrerecordedMessagesOutput>
{
  constructor(private usecase: FetchPrerecordedMessagesUsecase) {}

  async handle(): Promise<FetchPrerecordedMessagesOutput> {
    return this.usecase.run();
  }

  async handleHideComponent() {
    this.usecase.hideComponent();
  }
}
